import { render, staticRenderFns } from "./AuthHeader.vue?vue&type=template&id=589177c3&scoped=true&"
import script from "./AuthHeader.vue?vue&type=script&lang=js&"
export * from "./AuthHeader.vue?vue&type=script&lang=js&"
import style0 from "./AuthHeader.vue?vue&type=style&index=0&id=589177c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589177c3",
  null
  
)

export default component.exports